var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{key:"",staticClass:"singleChoiceItem",class:{ ischecked: _vm.isChecked },on:{"click":_vm.chioseChange}},[_c('div',{staticClass:"itemIcon"}),_c('span',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }